/* 🤖 this file was generated by svg-to-ts */
export const matIconSkipNext: {
  name: 'skip-next';
  data: string;
} = {
  name: 'skip-next',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m6 18 8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"/></svg>`
};
